module.exports = __webpack_public_path__ + "images/charity3.a75a46f2.svg";